import React from 'react'

function StockAudit() {
  return (
    <div>Stock Audit</div>
  )
}

export default StockAudit